module.exports = __webpack_public_path__ + "img/envelope.bc67d68e.svg";